import React, {Component} from 'react';
import {connect} from "react-redux";
import 'react-bootstrap';

import destinationApi from '../../../api/destinationApi';
import { lang } from '../../../config/lang';

class PlaceType extends Component {

    constructor(props)
    {
        super(props);
        this.state = {
            placeTypes : []
        }
        this.destinationID = props.id;
        this.lang = props.language.lang_key;
        this.allCount = 0;
        this.activeType = -1;

        this.handleViewAll = this.handleViewAll.bind(this);
        this.handleGetPlace = this.handleGetPlace.bind(this);
        this.getPlaceType = this.getPlaceType.bind(this);

    }

    componentWillMount() { 
        this.getPlaceType();
    }

    componentDidMount() {
           
    }
  
    componentWillUnmount() {
        
    }
    
    componentDidUpdate() {
        
    }

    componentWillReceiveProps(newProps) {
        if(this.destinationID !== newProps.id) {
            this.destinationID = newProps.id;
            this.getPlaceType();
        }
        if (this.lang !== newProps.language.lang_key) {
            this.lang = newProps.language.lang_key;
            this.getPlaceType();
        }
    }   

    
    getPlaceType() {
        destinationApi.getPlaceType(this.destinationID).then((json) => {
            if (json.status === 200 && json.data) {
                
                let i=0;
                let count=0;
                for(i; i < json.data.length; i ++) {
                    count = count + json.data[i].place_count;
                }
                this.allCount = count;
                this.setState({
                    placeTypes : json.data
                })
                
                
            } else {
                if (json.status === 620) {
                    
                } else {

                }
            }            
        });
    }

    handleViewAll() {
        this.activeType = -1; 
        this.props.viewAll();
    }

    handleGetPlace(ID, key) {
        
        this.activeType = key;
        this.props.getPlaceByType(this.destinationID, ID);
    }
  
    render() {
        return (
            <ul className="post-categories list-unstyled">
                <li>
                    <a onClick = {() =>this.handleViewAll()} className={this.activeType === -1 ? 'active' : ''}>{lang('view_all')} 
                        <span className="count">{` (${this.allCount})`}</span>
                    </a>
                </li>
                {
                    this.state.placeTypes.map((type, key) => (  
                        <li key={key}>
                            {
                                type.title !== null &&
                                <a  className={this.activeType === key ? 'active' : ''} 
                                    dangerouslySetInnerHTML={{__html: type.title +  '<span className="count"> ('+ type.place_count +')</span>'}} 
                                    onClick={() => this.handleGetPlace(type.id, key)}/>  
                                
                            }
                        </li>
                    ))
                }
                
            </ul>
        );
    }
}

function mapStateToProps(state) {
    return { 
        language: state.language
    };
}

export default connect(mapStateToProps)(PlaceType);